// Utils
import getOverflowingEdges from './getOverflowingEdges';
import { getRectCenterPoint } from '../../../../../common/maths/geometry/rect';

// Constants
import { RECT_CORNERS, RECT_EDGES } from '../../../../../common/maths/geometry/rect/rectConstants';

/**
 * Determines the corner that a target point or a target rectangle is overflowing.
 */
export default ({ targetPoint, targetRect, layerRect }) => {
    const target = targetPoint || getRectCenterPoint(targetRect);

    const overflowEdges = getOverflowingEdges({ targetPoint: target, layerRect });

    if (overflowEdges.length !== 2) return null;

    const overflowTop = overflowEdges.includes(RECT_EDGES.top);
    const overflowRight = overflowEdges.includes(RECT_EDGES.right);
    const overflowBottom = overflowEdges.includes(RECT_EDGES.bottom);
    const overflowLeft = overflowEdges.includes(RECT_EDGES.left);

    if (overflowTop && overflowRight) return RECT_CORNERS.TOP_RIGHT;
    if (overflowTop && overflowLeft) return RECT_CORNERS.TOP_LEFT;
    if (overflowBottom && overflowRight) return RECT_CORNERS.BOTTOM_RIGHT;
    if (overflowBottom && overflowLeft) return RECT_CORNERS.BOTTOM_LEFT;

    return null;
};
